import { z } from "zod"
import { NativeMessageSchema } from "./NativeMessage"
import { RequestPermissionMessageSchema } from "./RequestPermission"

export const PermissionsUpdatedMessageSchema = z.object({
  type: z.literal('permissionsUpdated'),
  permissions: z.record(RequestPermissionMessageSchema.shape.permission, z.union([z.boolean(), z.null()]))
}).extend(NativeMessageSchema.shape)

export type PermissionsUpdatedMessage = z.infer<typeof PermissionsUpdatedMessageSchema>